import Image from "next/image";
import { faqData } from "./data";
import { FAQItem } from "./faq-item";

export const FAQSection = () => {
  return (
    <div className="relative max-w-[1525px] mt-14 w-full py-12 px-4 md:px-8 lg:px-16 overflow-hidden">
      <Image
        src="/images/FAQ.png"
        alt="FAQ background"
        fill
        className="object-cover object-center -z-10"
        priority
      />
      <div className="max-w-[944px] mx-auto">
        <h1 className="text-4xl font-medium tracking-wide sm:text-6xl sm:font-bold text-white mb-12 sm:mb-16 text-center">
          FAQs
        </h1>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {faqData.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </div>
  );
};
